import { Referencer, ScopeManager } from 'eslint-scope'

import type { AnyNode, Identifier, Mustache, MustacheLiteral } from 'acorn'
import type { AnalyzeOptions } from 'eslint-scope'

class MustacheReferencer extends Referencer {
  Mustache(node: Mustache) {
    /**
     * NOTE: __nestGlobalScope 是 eslint-scope 内部的私有属性名，不是 rehaje 定义的
     * 这里需要给 esbuild 私有属性名转换插件加个白名单
     */
    this.scopeManager.__nestGlobalScope(node)
    node.body.forEach((child) => this.visit(child))
    this.close(node)
  }

  MustacheLiteral(node: MustacheLiteral) {
    this.visit({ ...node, type: 'Literal' })
    this.close(node)
  }
}

export class MustacheDependency {
  manager: ScopeManager
  options: AnalyzeOptions
  constructor(
    public node?: AnyNode,
    options?: AnalyzeOptions
  ) {
    this.options = { ecmaVersion: 2022, ...options }
    // @ts-ignore
    this.manager = new ScopeManager(this.options)
    if (node) new MustacheReferencer(this.options, this.manager).visit(node)
  }

  static extract(node?: AnyNode, options?: AnalyzeOptions): Identifier[] {
    if (!node) return []
    return new MustacheDependency(node, options).extract()
  }

  compile() {
    if (!this.node) return '[]'
    return `[${new MustacheDependency(this.node)
      .extract()
      .map((dep) => `${dep.name}${dep.subchain ?? ''}`)
      .join(',')}]`
  }

  extract(callback: (identifier: Identifier) => void): void
  extract(): Identifier[]
  extract(callback?: (identifier: any) => void): any {
    const identifiers = new Set()
    this.manager.globalScope.through.forEach((ref) => {
      const id = ref.identifier
      if (identifiers.has(id)) return
      identifiers.add(id)
      callback?.(id)
    })
    if (!callback) return Array.from(identifiers)
  }
}

export { type Identifier } from 'acorn'
